import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import type { NoSpecificData } from "@@/shared/socket-events/socket-event-base";
import type { CustomerId } from "@@/shared/users/customer-id";
import type { SystemUser } from "@@/shared/users/system-user";
import type { UserId } from "@@/shared/users/user-id";
import type { Order } from "../order";
import type {
    OrderSocketEventBase} from "./order-socket-event-base";
import {
    createOrderSocketEventBase,
} from "./order-socket-event-base";
import { createOrderSocketEventData } from "./order-socket-event-data";
import type { OrderSocketEventTypeName } from "./order-socket-event-type-name";

type TypeName = Extract<OrderSocketEventTypeName, "payrequest_fulfilled">;
type OrderPayRequestFulfilledSocketEvent = OrderSocketEventBase<TypeName>;

const createOrderPayRequestFulfilledSocketEvent = (params: {
    order: Order;
    triggeredBy: CustomerId | UserId | SystemUser;
    triggeredAt: IsoAndUnixTimestamp;
}): OrderPayRequestFulfilledSocketEvent => {
    const { order, triggeredAt, triggeredBy } = params;
    return createOrderSocketEventBase<TypeName>({
        for: [
            order.providerId,
            order.customerId,
            order.orderGroupId,
            order._id,
        ],
        type: "order:payrequest_fulfilled",
        triggeredAt,
        triggeredBy,
        data: createOrderSocketEventData<NoSpecificData>({
            order,
            triggeredBy,
        }),
    });
};
export { createOrderPayRequestFulfilledSocketEvent };
export type { OrderPayRequestFulfilledSocketEvent };
